import BaseModel from './BaseModel';
import DriverProfileModel from './DriverProfileModel';
import FileModel from './FileModel';
import { PropertyLocationModel } from './LocationModels';

export default class VehicleModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    // After the fleet_extension migration, `id` on this endpoint is the
    // equipment PK. The legacy vehicle PK (still required by trip / inspection
    // endpoints) is exposed as `legacy_vehicle_id`. Pre-migration responses
    // omit it, in which case `id` is already the legacy PK.
    this.legacy_vehicle_id = data.legacy_vehicle_id ?? null;
    this.external_id = data.external_id || '';

    this.name = data.name || this.external_id || `Vehicle #${this.id}`;

    this.vin = data.vin || '';
    this.year = data.year || 0;
    this.make = data.make || '';
    this.model = data.model || '';
    this.license_plate = data.license_plate || '';
    this.license_plate_state = data.license_plate_state || '';
    this.color = data.color || '';
    this.fuel_type = data.fuel_type || '';
    this.odometer = data.odometer || null;
    this.odometer_as_of = data.odometer_as_of || null;
    this.registration_number = data.registration_number || '';
    this.registration_expiration = data.registration_expiration || null;
    this.registration_document = data.registration_document ? new FileModel(data.registration_document) : null;
    this.insurance_provider = data.insurance_provider || '';
    this.insurance_policy_number = data.insurance_policy_number || '';
    this.insurance_expiration = data.insurance_expiration || null;
    this.insurance_document = data.insurance_document ? new FileModel(data.insurance_document) : null;
    this.assigned_drivers = (data.assigned_drivers || []).map(d => new DriverProfileModel(d));
    this.location = data.location && typeof data.location === 'object' ? PropertyLocationModel.factory(data.location) : data.location || null;
    this.image = data.image || null;
    this.thumbnail_url = data.image?.signed_url || data.image?.url || null;
    this.reservable = data.reservable ?? null;
    this.status = data.status || '';
    this.last_inspection_date = data.last_inspection_date || null;
    this.notes = data.notes || '';
    this.archived = data.archived || false;
  }

  get display_label() {
    if (this.location_name) {
      return `${this.name} (${this.location_name})`;
    }
    return this.name;
  }

  get location_name() {
    return (this.location && this.location.fullAncestryPath) || '';
  }

  matchesSearch(s) {
    if (!s) return true;
    const q = s.toLowerCase();
    return this.name.toLowerCase().includes(q)
      || this.make.toLowerCase().includes(q)
      || this.model.toLowerCase().includes(q)
      || this.display_label.toLowerCase().includes(q);
  }
}
